import { Spinner } from 'AWS-UI-Components-React';
import { TrendSummary } from './components/trend_summary';
import { TrendComponent } from './components/trend_component';
import { getJSClient } from '../js_client';
import { CHANNELS } from '../../constants/channels';
import { downloadFile } from '../../utilities';
import { ErrorFlash } from '../content/error_flash';

export class TrendReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shownSummaryMetrics: [],
      shownSummaryChannels: [],
      shownSummarySnapshots: [],
      shownSummaryAggregatedItems: [],
      shownComponentAccuracyKeys: [],
      shownComponentChannels: [],
      shownComponents: [],
      shownComponentSnapshots: [],
      shownComponentAggregatedItems: [],
    };
    this.trendGoals = {};
    this.reportData = null;
    this.marketplaceOptions = [];
  }

  componentDidMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.client.getChannelTrendGoalConfig(this.onChannelTrendGoalsConfigFetchSuccess);
    this.client.getComponentTrendGoalConfig(this.onComponentTrendGoalsConfigFetchSuccess);
    this.client.getMarketplaceConfig(this.onMarketplaceConfigFetchSuccess);
  };

  onChannelTrendGoalsConfigFetchSuccess = (response) => {
    this.storeTrendGoals(response.channelTrendGoalConfig);
  };

  onComponentTrendGoalsConfigFetchSuccess = (response) => {
    this.storeTrendGoals(response.componentTrendGoalConfig);
  };

  storeTrendGoals = (config) => {
    JSON.parse(config).map((goal) => (this.trendGoals[goal.id] = goal.trendGoal));
  };

  onMarketplaceConfigFetchSuccess = (response) => {
    this.marketplaceOptions = JSON.parse(response.marketplaceConfig)
      .filter((mp) => mp.enabled)
      .map((mp) => {
        return { label: mp.detail, id: mp.id };
      });
  };

  updateSelectedOptions = (chosen, stateName) => {
    this.setState({ [stateName]: chosen.detail.selectedOptions.map((o) => o.id) });
  };

  updateReportData = (reportData) => {
    this.reportData = reportData;
  };

  bothAccuracyAndVarianceSelected = (keys) => {
    return keys.some((k) => k.includes('Accuracy')) && keys.some((k) => k.includes('Variance'));
  };

  setDefaultData = (allChannels, snapshotSize, aggregateDefaultOptions) => {
    let retailOrFirstSelectedChannel = allChannels.includes(CHANNELS.RETAIL) ? CHANNELS.RETAIL : allChannels[0];
    this.setState({
      shownSummaryChannels: [retailOrFirstSelectedChannel],
      shownSummaryMetrics: ['lastCpAccuracy-cpAccuracy', 'firstCpAvAccuracy-cpAccuracy'],
      shownComponentChannels: [retailOrFirstSelectedChannel],
      shownComponentAccuracyKeys: ['dailyCPAccuracyAV', 'lastCPAccuracyNV'],
      shownSummarySnapshots: [...Array(snapshotSize).keys()],
      shownComponentSnapshots: [...Array(snapshotSize).keys()],
      shownSummaryAggregatedItems: aggregateDefaultOptions,
      shownComponentAggregatedItems: aggregateDefaultOptions,
    });
  };

  downloadDisplayedData = (data, displayedIds, filename, headingFormatter) => {
    this.setState({ reportDownloading: true });
    const monthHeadings = ['month', 'formattedMonth'];
    const headings = ['month/quarter', 'formatted time'].concat(
      Object.keys(data[0])
        .filter((key) => displayedIds.includes(key) && !monthHeadings.includes(key))
        .map((key) => headingFormatter(key))
    );
    let array = [headings.join('\t')];
    data.forEach((row) => {
      const rowItems = Object.keys(row)
        .filter((key) => displayedIds.includes(key) && !monthHeadings.includes(key))
        .map((key) => row[key]);
      const rowArray = [row.month, row.formattedMonth].concat(rowItems);
      array.push(rowArray.join('\t'));
    });
    downloadFile(array.join('\n'), filename);
    this.setState({ reportDownloading: false });
  };

  getDataForSharedMonths = (data, shownSnapshots) => {
    if (data.length === 0 || shownSnapshots.length === 0) {
      return data;
    }
    let sortedMonths = shownSnapshots.map((snapshotIndex) => {
      return this.reportData.sortedMonths;
    });
    let sharedMonth = sortedMonths.shift().filter((month) => {
      return sortedMonths.every((sortedMonth) => {
        return sortedMonth.indexOf(month) !== -1;
      });
    });
    return sharedMonth.map((month) => {
      return data[month];
    });
  };

  render() {
    const {
      shownSummaryChannels,
      shownSummaryMetrics,
      shownSummarySnapshots,
      shownSummaryAggregatedItems,
      shownComponentChannels,
      shownComponentAccuracyKeys,
      shownComponents,
      shownComponentSnapshots,
      shownComponentAggregatedItems,
    } = this.state;

    return (
      <div>
        {this.props.loading && !this.props.loadError && (
          <div>
            <Spinner />
            <div className="awsui-util-d-ib">Loading Data...</div>
          </div>
        )}
        {this.props.loading && this.props.loadError && (
          <ErrorFlash type={"Trend Report"} />
        )}
        {!this.props.loading && (
          <div>
            <TrendSummary
              title={'Summary Accuracy Trend'}
              shownChannels={shownSummaryChannels}
              shownAccuracyKeys={shownSummaryMetrics}
              shownSnapshots={shownSummarySnapshots}
              shownAggregatedItems={shownSummaryAggregatedItems}
              updateSelectedOptions={this.updateSelectedOptions}
              bothAccuracyAndVarianceSelected={this.bothAccuracyAndVarianceSelected}
              downloadDisplayedData={this.downloadDisplayedData}
              getDataForSharedMonths={this.getDataForSharedMonths}
              trendGoals={this.trendGoals}
              marketplaceOptions={this.marketplaceOptions}
              reportData={this.reportData}
              {...this.props}
            />
            <TrendComponent
              title={'Components Accuracy/Variance Trend'}
              updateReportData={this.updateReportData}
              shownChannels={shownComponentChannels}
              shownAccuracyKeys={shownComponentAccuracyKeys}
              shownComponents={shownComponents}
              shownSnapshots={shownComponentSnapshots}
              shownAggregatedItems={shownComponentAggregatedItems}
              updateSelectedOptions={this.updateSelectedOptions}
              bothAccuracyAndVarianceSelected={this.bothAccuracyAndVarianceSelected}
              setDefaultData={this.setDefaultData}
              downloadDisplayedData={this.downloadDisplayedData}
              getDataForSharedMonths={this.getDataForSharedMonths}
              trendGoals={this.trendGoals}
              marketplaceOptions={this.marketplaceOptions}
              {...this.props}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/trend_report_container.js